import {
    ServicesPageContainer,
    ServicePageOverlay,
    ServicePageBg,
    ServicePageContent,
    ServicePageTitle,
    ServicePageSecondContent,
    ServicePageSubText,
    ServicesPricingSection,
    ServicePageSubTextBottom
} from "../ServicesElements";
import {
    PricingGrid,
    PricingCard,
    PricingImage,
    PricingBody,
    PricingTitle,
    PricingList,
    PricingFooter,
    PricingFootText,
    PricingButton,
    PricingBanner
} from "../PricingElements";
import {
    DesktopOnly,
    MobileOnly,
    MobileContainer,
    MobileTitle,
    MobileVideo
} from "../../CommonElements";
import { useNavigate } from "react-router-dom";
import firstImage from "../../../images/pricing/promo1.jpg";
import secondImage from "../../../images/pricing/promo2.jpg";
import thirdImage from "../../../images/pricing/promo3.jpg";

const Promotional = () => {
    const navigate = useNavigate();
    const plans = [
    {
        img: firstImage,
        title: "Essential Promo",
        price: "£790",
        features: [
            "1 Full Filming Day (4-8 hours)",
            "Promotional Film (2-3 minutes)",
            "Drone Shots",
            "Premium Editing",
            "Audio Mastering",
            "Full Script and Professional Contract",
            "Licensed Commercial Music",
            "1 Round of Revision"

        ],
        footText: "For businesses seeking a professional video that effectively sells.",
        cta: "Learn More",
        link: "/summary?type=promotional_basic",
    },
    {
        img: secondImage,
        title: "Cinematic Social Boost",
        price: "£1390",
        noListStyle: true,
        banners: [
            "Includes everything from Package 1"
        ],
        features: [
            "+ 3 Vertical Social Media Reels",
            "+ Trend Research",
            "+ 1 Short Cut-down of the Main Film",
            "+ Mini Photo Pack (10 images)"

        ],
        footText: "For businesses that want a professional promotional film plus ready-made social media content to maximise visibility.",
        cta: "Learn More",
        link: "/summary?type=promotional_standard",
    },
    {
        img: thirdImage,
        title: "Full Brand Video Suite",
        price: "£2690",
        noListStyle: true,
        banners: [
            "Includes everything from Package 1",
            "Includes everything from Package 2"
        ],
        features: [
            "+ 6x Vertical Social Media Reels",
            "+ BTS (Behind The Scenes) Video",
            "+ Loop Background Video",
            "+ 1 Month Content Strategy",
            "+ 3x Short Cut-Downs of the Main Film",
            "+ Mini Photo Pack (15 images)",
            "+ 2 Rounds of Revision"

        ],
        footText: "For brands ready to dominate social media and own a complete video toolkit for all communication channels.",
        cta: "Learn More",
        link: "/summary?type=promotional_premium",
    },
    ];

    return (
        <>
            <DesktopOnly>
                <ServicesPageContainer>
                    <ServicePageBg>
                        <video autoPlay loop muted playsInline className="App-logo">
                        <source src="/videos/promotional_video_background.mp4" type="video/mp4" />
                        </video>
                        <ServicePageOverlay />
                    </ServicePageBg>

                    <ServicePageContent>
                        <ServicePageTitle>
                        Promotional & Corporate videos for companies 
                        <br />
                        <br />
                        <br />
                        looking to attract customers and investors
                        <br />
                        </ServicePageTitle>
                    </ServicePageContent>
                </ServicesPageContainer>
            </DesktopOnly>

            <MobileOnly>
                <MobileContainer>
                    <MobileTitle mobileFontSize="15px">
                        Promotional & Corporate videos for companies 
                        <br />
                        looking to attract customers and investors
                    </MobileTitle>
                    <MobileVideo
                    autoPlay
                    muted
                    playsInline
                    loop
                    src="/videos/promotional_video_background.mp4"
                    />
                </MobileContainer>
            </MobileOnly>

        <ServicePageSecondContent>
            <ServicePageSubText>
                We craft compelling stories that highlight your brand's strengths and deliver your message with clarity and impact.
                <br />
                <br />
                <br />
                From dynamic product showcases to powerful corporate narratives, our promotional videos are designed to engage, inspire, and convert.
                <br />
                <br />
                <br />
                Let your brand stand out with visuals that leave a lasting impression.
                <br />
                <br />
                <br />
                Choose the Plan That Fits You Best
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicesPricingSection>
            <PricingGrid>
                {plans.map((p) => (
                    <PricingCard key={p.title}>
                    {p.img && <PricingImage src={p.img} alt={p.title} mobileHeight="280px"/>}
                    <PricingBody>
                        <PricingTitle>{p.title} <span style={{fontSize: '18px'}}>{p.price}</span></PricingTitle>
                        {p.banners && p.banners.length > 0 && (
                        <>
                            {p.banners.map((banner, idx) => (
                            <PricingBanner
                                key={idx}
                                variant={idx === 0 ? "gold" : idx === 1 ? "diamond" : "blue"}
                            >
                                {banner} {idx === 0 ? "🚀" : idx === 1 ? "💎" : "⭐"}
                            </PricingBanner>
                            ))}
                        </>
                        )}
                        <PricingList style={{ listStyle: p.noListStyle ? "none" : "disc", paddingLeft: p.noListStyle ? "0" : "18px" }}>
                        {p.features.map((f) => (
                            <li key={f}>{f}</li>
                        ))}
                        </PricingList>
                    </PricingBody>
                    <PricingFooter>
                        <PricingFootText>{p.footText}</PricingFootText>
                        <PricingButton type="button" aria-label={p.cta} onClick={() => navigate(p.link)}>
                        {p.cta}
                        </PricingButton>
                    </PricingFooter>
                    </PricingCard>
                ))}
            </PricingGrid>
        </ServicesPricingSection>
        <ServicePageSecondContent>
            <ServicePageSubText>
                Didn't find the right package? 
                <br />
                <br />
                <PricingButton type="button" aria-label={"👉 Request a Custom Quote"} onClick={() => navigate("/contact")}>
                    👉 Request a Custom Quote
                </PricingButton>
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicePageSecondContent>
            <ServicePageSubTextBottom>
                <b>Show</b> your brand at its best
                <br />
                <br />
                <b>Turn</b> your ideas into powerful stories
                <br />
                <br />
                <b>Inspire</b> trust, attract clients and win investors
                <br />
                <br />
            </ServicePageSubTextBottom>
        </ServicePageSecondContent>
        </>
    )
};

export default Promotional;